/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BytesLike,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PolyBlade, PolyBladeInterface } from "../PolyBlade";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint16",
        name: "initMaxSupply",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "initSaleStart",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "initFixedPrice",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "initOldAddress",
        type: "address",
      },
      {
        internalType: "address",
        name: "vrfCoordinator",
        type: "address",
      },
      {
        internalType: "address",
        name: "linkToken",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "keyHash",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "token",
        type: "uint256",
      },
    ],
    name: "FulfillMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
    ],
    name: "RequestMint",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "BURN_ADDRESS",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "mintCount",
        type: "uint16",
      },
    ],
    name: "batchMint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "claim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "devMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "devMintRandom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newPrice",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "numberOfMints",
        type: "uint16",
      },
    ],
    name: "discountMintPrice",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "discountedMintsRemaining",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "emergencyFulfill",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "fixedPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint16",
        name: "startId",
        type: "uint16",
      },
      {
        internalType: "uint16",
        name: "endId",
        type: "uint16",
      },
    ],
    name: "initializeMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "isSaleActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "mint",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "mintsRemaining",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "oldPolybladeAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "price",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "requestId",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "randomness",
        type: "uint256",
      },
    ],
    name: "rawFulfillRandomness",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint16",
        name: "reserveCount",
        type: "uint16",
      },
    ],
    name: "reserveClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleStart",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newSaleStart",
        type: "uint256",
      },
    ],
    name: "setSaleStart",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "toggle",
        type: "bool",
      },
    ],
    name: "togglePause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "toggle",
        type: "bool",
      },
    ],
    name: "toggleSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "unreserveClaim",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newFee",
        type: "uint256",
      },
    ],
    name: "updateLinkFee",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
    ],
    name: "withdrawErc20",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class PolyBlade__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    initMaxSupply: BigNumberish,
    initSaleStart: BigNumberish,
    initFixedPrice: BigNumberish,
    initOldAddress: string,
    vrfCoordinator: string,
    linkToken: string,
    keyHash: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<PolyBlade> {
    return super.deploy(
      initMaxSupply,
      initSaleStart,
      initFixedPrice,
      initOldAddress,
      vrfCoordinator,
      linkToken,
      keyHash,
      overrides || {}
    ) as Promise<PolyBlade>;
  }
  getDeployTransaction(
    initMaxSupply: BigNumberish,
    initSaleStart: BigNumberish,
    initFixedPrice: BigNumberish,
    initOldAddress: string,
    vrfCoordinator: string,
    linkToken: string,
    keyHash: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      initMaxSupply,
      initSaleStart,
      initFixedPrice,
      initOldAddress,
      vrfCoordinator,
      linkToken,
      keyHash,
      overrides || {}
    );
  }
  attach(address: string): PolyBlade {
    return super.attach(address) as PolyBlade;
  }
  connect(signer: Signer): PolyBlade__factory {
    return super.connect(signer) as PolyBlade__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): PolyBladeInterface {
    return new utils.Interface(_abi) as PolyBladeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PolyBlade {
    return new Contract(address, _abi, signerOrProvider) as PolyBlade;
  }
}
